import {Directive, Input} from '@angular/core';
import {ExternalValidatorRule, IValidationRuleError} from '../../rules/rules';
import {BaseValidatorDirective} from './base-validator.directive';
import {NG_VALIDATORS} from '@angular/forms';

export type ExternalValidator = ($value: any, $formData?: any) => (IValidationRuleError | null);

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[ngModel][externalValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: ExternalValidatorDirective,
            multi: true,
        }
    ],
})
export class ExternalValidatorDirective extends BaseValidatorDirective<ExternalValidatorRule> {
    @Input()
    public set externalValidator($value: ExternalValidator) {
        this.rule = $value && new ExternalValidatorRule($value);
    }
}
